import { useContext } from 'react';

import { enableExperimentFeatures } from '@/config/experiment-feature-toggles';
import { FeatureToggleContext } from '@/contexts';
import { useAbTastyTests } from '@/hooks/use-ab-tasty-tests';

export const useFeatureToggle = () => {
  const { enabledFeatures } = useContext(FeatureToggleContext);
  const abTastyTests = useAbTastyTests();

  const experimentFeatures = enableExperimentFeatures(
    enabledFeatures,
    abTastyTests
  );
  const isEnabled = (featureName: string) => experimentFeatures[featureName];

  return { isEnabled };
};
